import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { Record, Map as ImmutableMap, List } from 'immutable';
import I18n from 'I18n';
import TimeRange from 'MeetingsBase/models/TimeRange';
import { unify } from 'MeetingsBase/utils/TimeRangeListUtils';
import { validTimeRange } from 'MeetingsBase/utils/dates';
import { AVAILABILITY_OPTIONS, WEEKDAYS_LIST, AVAILABLE_DAYS } from 'MeetingsBase/constants/dates';
var defaults = Object.keys(AVAILABILITY_OPTIONS).reduce(function (accumulator, day) {
  return Object.assign({}, accumulator, _defineProperty({}, day, List()));
}, {});

var Availability = /*#__PURE__*/function (_Record) {
  _inherits(Availability, _Record);

  function Availability() {
    _classCallCheck(this, Availability);

    return _possibleConstructorReturn(this, _getPrototypeOf(Availability).apply(this, arguments));
  }

  _createClass(Availability, [{
    key: "isValid",
    value: function isValid() {
      var _this = this;

      return Object.keys(AVAILABILITY_OPTIONS).every(function (option) {
        return !_this.has(option) || _this.get(option).every(function (timeRange) {
          return validTimeRange(timeRange);
        });
      });
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.reduce(function (t, a) {
        return t + a.size;
      }, 0) === 0;
    }
  }, {
    key: "getForDateString",
    value: function getForDateString(dateString) {
      var weekDayIndex = I18n.moment(dateString).day();
      return this.getForWeekDayIndex(weekDayIndex);
    }
  }, {
    key: "getUnmergedForWeekDay",
    value: function getUnmergedForWeekDay(weekDay) {
      switch (weekDay) {
        case AVAILABLE_DAYS.SATURDAY:
        case AVAILABLE_DAYS.SUNDAY:
          return this[weekDay].concat(this[AVAILABILITY_OPTIONS.SAT_SUN]).concat(this[AVAILABILITY_OPTIONS.EVERY_DAY]);

        case AVAILABLE_DAYS.MONDAY:
        case AVAILABLE_DAYS.TUESDAY:
        case AVAILABLE_DAYS.WEDNESDAY:
        case AVAILABLE_DAYS.THURSDAY:
        case AVAILABLE_DAYS.FRIDAY:
          return this[weekDay].concat(this[AVAILABILITY_OPTIONS.MON_FRI]).concat(this[AVAILABILITY_OPTIONS.EVERY_DAY]);

        default:
          return this[weekDay].concat(this[AVAILABILITY_OPTIONS.EVERY_DAY]);
      }
    }
  }, {
    key: "getForWeekDayIndex",
    value: function getForWeekDayIndex(index) {
      var weekDay = WEEKDAYS_LIST[index];
      var unmergedAvailabilityForWeekDay = this.getUnmergedForWeekDay(weekDay);
      return unify(unmergedAvailabilityForWeekDay);
    }
  }, {
    key: "setForWeekDayIndex",
    value: function setForWeekDayIndex(availability, index) {
      return this.set(WEEKDAYS_LIST[index], availability);
    }
  }, {
    key: "reduce",
    value: function reduce(accumulator, initial) {
      var _this2 = this;

      var keys = Object.keys(AVAILABILITY_OPTIONS);
      return keys.reduce(function (acc, option) {
        return accumulator(acc, _this2.get(option), option);
      }, initial);
    }
  }], [{
    key: "from",
    value: function from(json) {
      var availability = this._fromWithoutValidation(json);

      return availability.reduce(function (newAvailability, timeRanges, dayKey) {
        newAvailability = newAvailability.set(dayKey, timeRanges.filter(function (timeRange) {
          return validTimeRange(timeRange);
        }));
        return newAvailability;
      }, new Availability());
    }
  }, {
    key: "_fromWithoutValidation",
    value: function _fromWithoutValidation(json) {
      if (!json) {
        return new Availability();
      }

      var jsonMap = ImmutableMap(json);
      var formattedData = jsonMap.map(function (timeRanges) {
        if (!timeRanges) {
          return timeRanges;
        }

        var timeRangesList = List(timeRanges);
        return timeRangesList.map(TimeRange.from);
      });
      var sortedAvailability = formattedData.map(function (timeRanges) {
        return timeRanges ? timeRanges.sort(function (timeRangeA, timeRangeB) {
          return timeRangeA.end - timeRangeB.end;
        }) : timeRanges;
      });
      return sortedAvailability;
    }
  }]);

  return Availability;
}(Record(defaults));

export { Availability as default };